import { Component, OnInit, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UpperCasePipe } from '@angular/common';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LoggerService } from '@app/shared/services/logger.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { UserRepository } from '@app/shared/state/user/user.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-rich-club-bonus',
  imports: [
    ButtonComponent,
    UpperCasePipe,
    TranslateModule,
    SharedModule,
    DisplayComponent,
    TranslateModule,
    ButtonComponent,
  ],
  templateUrl: './rich-club-bonus.component.html',
  styleUrl: './rich-club-bonus.component.scss',
  standalone: true,
})
export class RichClubBonusComponent implements OnInit {
  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);
  loggerService = inject(LoggerService);
  private userRepo = inject(UserRepository);
  richClubData = inject<ModalConfig>(MAT_DIALOG_DATA);

  componentDestroy: () => Observable<unknown>;
  lang: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    this.userRepo.updateUser({
      nextRichBonusRedeemDate: new Date(this.richClubData.properties.nextDate),
    });

    this.eventManager.isNextRichBonusAvailable(new Date(this.richClubData.properties.nextDate).getTime());

    this.eventManager.closeModal(new Modal(this.richClubData.id, ModalType.Persisted, this.richClubData));
  }
}
